// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 973 ? "graphiql" : chunkId) + ".js?" + {"196":"176df09ddbc03f2cebd2","973":"5fc4203011351f19a3cd"}[chunkId] + "";
};